var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"chart-container",style:({
    height: _vm.chartHeight + 'px',
  })},[_c('LineChart',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(function (isVisible) { return (isVisible ? _vm.resizeContainer() : false); }),expression:"isVisible => (isVisible ? resizeContainer() : false)"}],ref:"chart",style:({
      height: _vm.chartHeight + 'px',
    }),attrs:{"hide-legends":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }